import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Note, NoteTemplateItem } from '../../models/domain/note';
import { Router } from '@angular/router';


export interface IAddNotePromptDialogModel {
    title: string;
    subTitle ?: string;
    message ?: string;
    MemberID ?: number;
    noteTemplate ?: string;
    showCancel: boolean;
    okText ?: string;
    okLinkURL ?: string;
    showServerButtons ?: boolean;
}


@Component({
    selector: 'add-note-prompt-dialog',
    styleUrls: ['./add.note.prompt.dialog.scss'],
    templateUrl: './add.note.prompt.dialog.html'
})
export class AddNotePromptDialog extends DialogComponent<IAddNotePromptDialogModel, string> implements IAddNotePromptDialogModel, OnInit {
    @ViewChild('NoteField') noteField: ElementRef;

    title: string = 'Add Note';
    subTitle: string = 'For recording purposes';
    message: string;
    MemberID: number;
    noteTemplate: string = '';
    showCancel: boolean = false;

    noteTemplates: NoteTemplateItem[] = [];
    selectedNoteTemplate: NoteTemplateItem;
    // selectedProduct: number;

    okText: string = 'OK';
    okLinkURL: string = '';
    showServerButtons: boolean = false;

    noteBody: string = 'description';

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.SetupTemplates();
        if (this.okLinkURL != '') {

        }
        this.FocusInput();
    }


    SetupTemplates() {

        this.noteTemplates = Note.NoteTemplates;

        this.selectedNoteTemplate = this.noteTemplates[0];

        if (this.noteTemplate != '') {
            this.noteTemplates.forEach(x => {
                if (x.Title == this.noteTemplate) {
                    this.selectedNoteTemplate = x;
                }
            });
        }

        this.TemplateChanged();
    }

    async confirm() {
        this.result = this.noteBody;
        this.close();
    }

    confirmWithServer(server: string) {
        this.result = server + '::' + this.noteBody;
        this.close();
    }

    Cancel() {
        this.result = 'cancel';
        this.close();
    }

    TemplateChanged() {

        this.noteBody = this.selectedNoteTemplate.Title + '\n' + this.selectedNoteTemplate.Body;
        if (this.noteBody.includes('No Template'))
            this.noteBody = '';

        this.FocusInput();
    }

    DisableSave() {
        let selectedNoteBody = this.selectedNoteTemplate.Title + '\n' + this.selectedNoteTemplate.Body;
        if (this.noteBody == '' || this.noteBody == selectedNoteBody) {
            return true;
        } else {
            return false;
        }
    }

    FocusInput() {
        setTimeout(() => {
            this.noteField.nativeElement.focus()
        }, 50)
    }


}
